import React from 'react';
import { useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';

import {
  clearLibraryData,
  setExcelUploadErrors,
  setShowExcelUploadErrors,
} from 'redux/actions';

export const ClearLibraryModal = ({ clearLibrary, setClearLibrary }) => {
  const dispatch = useDispatch();
  return (
    <Modal
      title='Clear Library'
      visible={clearLibrary}
      onCancel={() => setClearLibrary(false)}
      footer={[
        <Button key='cancel' onClick={() => setClearLibrary(false)}>
          Cancel
        </Button>,
        <Button
          key='delete'
          type='primary'
          onClick={() => {
            dispatch(clearLibraryData());
            dispatch(setExcelUploadErrors(null));
            dispatch(setShowExcelUploadErrors('hide'));
            setClearLibrary(false);
          }}
          danger
        >
          Clear
        </Button>,
      ]}
    >
      Are you sure you want to clear the library?
    </Modal>
  );
};
